define('drops/requirementsGraph/barvalue',[],function() {
    'use strict';

    function BarValue(id, xValue, selectedValue, preferredValue) {
        this.id = id;
        this.xValue = xValue;
        this.selectedValue = selectedValue;
        this.preferredValue = preferredValue === undefined ? selectedValue : preferredValue;

        this.originalSelectedValue = this.selectedValue;
        this.originalPreferredValue = this.preferredValue;
    };

    BarValue.prototype.hasChanged = function() {
        if (this.originalSelectedValue != this.selectedValue) {
            return true;
        }

        if (this.originalPreferredValue != this.preferredValue) {
            return true;
        }

        return false;
    };

    return BarValue;
});
